<template>
    <section>
        <div class="row">
            <div class="col-12">
                <label class="versetab">Favourites</label>
                <div class="verse-cont">
                    <div v-if="this.$store.getters.getLoggedInState">
                        <div v-if="favouritesDetails === undefined || favouritesDetails.length == 0 ">
                            <p class="verse-message">Save favourite verses.</p>
                        </div>
                        <div v-else>
                            <div v-for="(bookDetail, i) in favouritesDetails" :key="i">
                                <div :id="favouritesDetails[i].bookName + bookDetail.chapterAndVerse" class="verse-item">
                                    <h4>{{ favouritesDetails[i].bookName }}</h4>
                                    <blockquote>
                                    <h5>{{ bookDetail.chapterAndVerse }}</h5>
                                    <p>{{ bookDetail.verseText }}</p>
                                    </blockquote>
                                    <button class="btn btn-success delete" @click.prevent="deleteVerse(favouritesDetails[i].bookName + bookDetail.chapterAndVerse)">X</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="this.$store.getters.getFavouritesLoadedState">
                        <div v-for="(bookDetail, i) in favouritesDetails" :key="i">
                            <div :id="favouritesDetails[i].bookName + bookDetail.chapterAndVerse" class="verse-item">
                                <h4>{{ favouritesDetails[i].bookName }}</h4>
                                <blockquote>
                                <h5>{{ bookDetail.chapterAndVerse }}</h5>
                                <p>{{ bookDetail.verseText }}</p>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="verse-message">Login to save/view your favourite verses.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            favouritesDetails: Array
        },
        methods: {
            deleteVerse(verse) {
                this.$parent.removeFirebaseDataChild(verse);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FavouriteItem.vue